import { render, staticRenderFns } from "./CouponRecords.vue?vue&type=template&id=5c0e4443&"
import script from "./CouponRecords.vue?vue&type=script&lang=js&"
export * from "./CouponRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports